import { Badge } from '@/components/ui/badge';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import type { UserRoleInfo } from '../types';

interface RolesCellProps {
  roles: UserRoleInfo[];
}

export function RolesCell({ roles }: RolesCellProps) {
  // No roles
  if (roles.length === 0) {
    return <span className="text-muted-foreground text-sm">No roles</span>;
  }

  // Single role - show as badge
  if (roles.length === 1) {
    return <Badge variant="secondary">{roles[0].roleName}</Badge>;
  }

  // Multiple roles - show count with hover tooltip
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge variant="outline" className="cursor-default">
            {roles.length} roles
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="bottom" align="start" className="max-w-xs">
          <ul className="space-y-1">
            {roles.map((role) => (
              <li key={role.roleId} className="text-sm">
                <span className="font-medium">{role.roleName}</span>
                <span className="text-muted-foreground ml-2">({role.roleCode})</span>
              </li>
            ))}
          </ul>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
